export default {"src":"/_next/static/media/circlepcc.94aad35c.svg","height":194,"width":194};